import axios from '@/utils/axiosInt.js'
let http = {
    allData: function ({
        section = null,
        type = null
    }) { //消费量全国合计
        return axios.post('/bi-api/customer/total?time=' + new Date() * 1, {
            timeSection: section,
            type: type,
        })
    },
    allProvince: function ({
        section = null,
        type = null,
        provinceCode = null
    }) {
        return axios.post('/bi-api/customer/getProvince?time=' + new Date() * 1, {

            timeSection: section,
            type: type,
            provinceCode: provinceCode
        })
    },
    allCity: function ({
        section = null,
        type = null,
        provinceCode = null,
        cityCode = null,
    }) { //消费量全市数据
        return axios.post('/bi-api/customer/getcity?time=' + new Date() * 1, {
            timeSection: section,
            type: type,
            provinceCode: provinceCode,
            cityCode: cityCode
        })
    },
    allSity: function ({
        section = null,
        type = null,
        cityCode = null
    }) { //消费量全市数据
        return axios.post('/bi-api/customer/getsity?time=' + new Date() * 1, {
            timeSection: section,
            type: type,
            cityCode: cityCode
        })
    },
    allCountCard: function ({
        timeSection = null
    }) {
        return axios.post('/bi-api/cardCustomer/getTotalProvince?time=' + new Date() * 1, {
            timeSection: timeSection
        })
    },
    allCard: function ({
        timeSection = null,
        provinceCode = null,
        cityCode = null,
        type = null
    }) {
        // return axios.post('/bi-api/cardCustomer/getProvince?time=' + new Date() * 1, {
        return axios.post('/bi-api/cardCustomer/getProvince2?time=' + new Date() * 1, {
            timeSection: timeSection,
            provinceCode: provinceCode,
            cityCode:cityCode,
            type:type
        })
    },
    // cityCard: function ({
    //     section = null,
    //     provinceCode = null
    // }) {
    //     return axios.post('/bi-api/customer/getcity?time=' + new Date() * 1, {
    //         timeSection: section,
    //         provinceCode: provinceCode
    //     })
    // },
    dotData: function ({
        section = null,
        code = null
    }) {
        return axios.post('/bi-api/customer/getsity?time=' + new Date() * 1, {
            timeSection: section,
            cityCode: code
        })
    },
    searchData: function ({
        timeSection = null,
        siteCode = null
    }) {
        return axios.post('/bi-api/customer/getsityInfo?time=' + new Date() * 1, {
            timeSection: timeSection,
            siteCode: siteCode
        })
    },
    provCard: function ({
        timeSection = null,
        provinceCode = null,
        cityCode = null,
    }) {
        return axios.post('/bi-api/cardCustomer/getcity?time=' + new Date() * 1, {
            timeSection,
            provinceCode,
            cityCode,
        })
    },
    siteCard: function ({
        timeSection = null,
        cityCode = null
    }) {
        return axios.post('/bi-api/cardCustomer/getsity?time=' + new Date() * 1, {
            timeSection: timeSection,
            cityCode: cityCode
        })
    },
    cardcountryData: function ({
        start,
        end,
        reqId
    }) {
        return `/bi-api/consumeexport/cardcountryData?start=${start}&end=${end}&reqId=${reqId}`
    },
    cityData: function ({
        start,
        end,
        provinceCode,
        reqId
    }) {
        return `/bi-api/consumeexport/cityData?start=${start}&end=${end}&provinCode=${provinceCode}&reqId=${reqId}`
    },
    cardSity: function ({
        start,
        end,
        cityCode,
        reqId
    }) {
        return `/bi-api/consumeexport/cardSity?start=${start}&end=${end}&cityCode=${cityCode}&reqId=${reqId}`
    },
    progress: function ({
        reqId
    }) {
        return axios.get(`/bi-api/export/getProgress?reqId=${reqId}&_=${new Date()*1}`)
    },
    countryData: function ({
        start,
        end,
        reqId
    }) {
        return `/bi-api/consumeexport/countryData?start=${start}&end=${end}&reqId=${reqId}`
    },
    logEx: function({ provinceCode,cityCode,startTime,endTime }) {
        return `/bi-api/loginLog/export?provinceCode=${provinceCode}&cityCode=${cityCode}&startTime=${startTime}&endTime=${endTime}&reqId=${+new Date()}`
    },
    getCountyAreaList({code,areaType,type}) {
        //高速加油站停靠 高速运营时段
        return axios.get(
            `/bi-api/getCountyAreaList?code=${code}&areaType=${areaType}&type=${type}&time=` + new Date() * 1,
        )
    },
    ExportCity: function ({
        start,
        end,
        provinceCode,
        reqId
    }) {
        return `/bi-api/consumeexport/ExportCity?start=${start}&end=${end}&provinCode=${provinceCode}&reqId=${reqId}`
    },
    ExportSity: function ({
        start,
        end,
        cityCode,
        reqId
    }) {
        return `/bi-api/consumeexport/ExportSity?start=${start}&end=${end}&cityCode=${cityCode}&reqId=${reqId}`
    },
};
export default http
